<script lang="ts">
    import type { SvelteComponent } from 'svelte';
    import { Breadcrumb, BreadcrumbItem } from "flowbite-svelte";
    import CustomBreadcrumbItem from "./CustomBreadcrumbItem.svelte";
    import { LABEL } from "../../constants/label-constants.js";
    import { navigateTo } from "../../services/routing/route-action.js";
    import { userStore } from "../../services/stores/user-store.js";

    export let items: Array<{ label: string; href?: string }> = [];

    function handleClick(event: CustomEvent<{ event: MouseEvent; href: string }>) {
        const { href } = event.detail;
        const routeName = href.replace("/", "");
        navigateTo(routeName);
    }

    // Check if user is an OH user (not a customer) based on claims
    $: isOHUser = $userStore?.claims?.canManageCustomers || 
                  $userStore?.claims?.canManageProjects || 
                  $userStore?.claims?.canManageUsers || 
                  $userStore?.user?.user_type === 'oh-user';
    
    // Check if user is a customer
    $: isCustomerUser = $userStore?.user?.user_type === 'customer';
    
    // Get customer name for customer users
    $: customerName = isCustomerUser && $userStore?.user?.customers && $userStore.user.customers.length > 0 
        ? $userStore.user.customers[0].name 
        : null;
</script>

{#if isOHUser}
<!-- Full breadcrumb navigation for OH users -->
<Breadcrumb navClass="app-breadcrumb" aria-label="Default breadcrumb example">
    <CustomBreadcrumbItem href="/home" home on:click={(event) => handleClick(event)}>{LABEL.HOME}</CustomBreadcrumbItem>
    {#each items as { label, href } (href)}
        {#if href}
            <CustomBreadcrumbItem {href} on:click={(event) => handleClick(event)}>{label}</CustomBreadcrumbItem>
        {:else}
            <BreadcrumbItem>{label}</BreadcrumbItem>
        {/if}
    {/each}
</Breadcrumb>
{:else if isCustomerUser && customerName}
<!-- Simple plain text display for customer users -->
<div class="app-breadcrumb customer-breadcrumb" aria-label="Customer context">
    <span class="customer-name-text">{customerName}</span>
</div>
{/if}
